const React = require('react');

const Loader = (properties) => {
   return  <div className="changesVisualizationLoading"
         style={properties.displayLoading ? {} : {visibility: "hidden"}}>Loading...</div>;
}


module.exports = Loader;
